import { render, staticRenderFns } from "./Contratosv2.vue?vue&type=template&id=2ea3b38a"
import script from "./Contratosv2.vue?vue&type=script&lang=js"
export * from "./Contratosv2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports